import IconCircleCheckSolid from '@/assets/icons/font_awesome/circle-check-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';

export const WSButtonFeaturesAllowAllNewUsersTemplate = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  async function onClick() {
    let workspace_current_new = workspace_current.clone({ permitted_features_for_new_workspace_users: Object.keys(ENUM__workspace_entity_feature) });

    await dispatch(remote_workspace_update(workspace_current_new));
  }

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_page_settings_workspace.tabs.features_access.button.allow_all_features.tooltip)}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={IconCircleCheckSolid}
        onClick={onClick}
        disabled={workspace_current.permitted_features_for_new_workspace_users.length === Object.keys(ENUM__workspace_entity_feature).length}
        className="w-5 h-5 !p-0"
        iconClassNameBase="!w-5 !h-5"
        iconClassNameHovered={'!text-component-item'}
        iconClassNameNonHovered={'!text-component-item-foreground '}
      />
    </UI_PRIMITIVE__tooltip>
  );
};
